import { Dispatch } from "react";
import { AppState } from "./configureStore";
import { createSlice, PayloadAction, AnyAction } from '@reduxjs/toolkit';
import { client } from "../App";
import { ErrorHandling } from "../DCR.dtos"

export interface IErrorHandlingState {
    page: string;
    message: string;
}

export const initialErrorHandlingState: IErrorHandlingState = {
    page: '/',
    message: ''
};

const slice = createSlice({
    name: 'errorHandling',
    initialState: {} as IErrorHandlingState,
    reducers: {
        setErrorHandling: (state: IErrorHandlingState, action: PayloadAction<{ page: string; message: string }>) => {
            const { page, message } = action.payload;
            return {
                ...state,
                page,
                message
            }
        }
    }
})

const { setErrorHandling } = slice.actions;

function logError(message?: string) {
    return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
        const previousPage = getState().errorHandling.page;
        const previousMessage = getState().errorHandling.message;
        const page = getState().router.location.pathname;
        message = message || '';

        //Do not log error if page/message isn't different
        if (page === previousPage && message === previousMessage) {
            return
        }

        dispatch(setErrorHandling({ page, message }));

        try {
            await client.post(new ErrorHandling({ message, page }));

        } catch (e) {
            console.log(e);
        }

    }
}

export const errorHandlingActionCreators = {
    logError
};

export const errorHandlingReducer = slice.reducer;